import { useState } from "react";
import PropTypes from "prop-types";
import api from '../../config/axiosConfig';
import { toast } from "react-toastify";
import Preloader from "../../components/Preloader";

const ImportarVenta = ({ onClose, token, onSuccess }) => {
  const [archivo, setArchivo] = useState(null);
  const [loading, setLoading] = useState(false);

  const handleFileChange = (e) => {
    setArchivo(e.target.files[0]);
  };

  const handleImportar = async () => {
    if (!archivo) return;
    setLoading(true);

    const formData = new FormData();
    formData.append("archivo", archivo);

    try {
      const response = await api.post("/ventas/importar",
        formData,
        {
          timeout: 0,
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      const { success, resultados } = response.data;

      if (success) {
        const errores = resultados.filter((r) => r.accion === "error");
        if (errores.length > 0) {
          // --- GENERACIÓN DEL ARCHIVO TXT ---
          // Creamos el contenido del texto
          const cabecera = `REPORTE DE ERRORES DE IMPORTACIÓN - ${new Date().toLocaleString()}\n`;
          const separador = "----------------------------------------------------------\n";
          const cuerpo = errores
            .map((e) => `Código: ${e.documento} | Motivo: ${e.motivo}`)
            .join("\n");

          const contenidoTxt = cabecera + separador + cuerpo;

         
          const blob = new Blob([contenidoTxt], { type: "text/plain" });
          const url = window.URL.createObjectURL(blob);

          const link = document.createElement("a");
          link.href = url;
          link.download = `errores_importacion_${Date.now()}.txt`;
          document.body.appendChild(link);
          link.click();

          link.remove();
          window.URL.revokeObjectURL(url);

          toast.warning("Importación completada con algunos errores. Se ha descargado un archivo de reporte.");
        } else {
          toast.success("Ventas Importadas Exitosamente");
        }

      }

      setLoading(false);
      onSuccess()
      onClose();
    } catch (error) {
      setLoading(false);
      const mensajeError =
        error.response?.data?.error || "Error inesperado al importar";
      toast.error(` ${mensajeError}`);
    }
  };

  return (
    <div className="modal-overlay-import">
      {loading && <Preloader />}
      <div className="modal-box-import">
        <div className="modal-header">
          <span> Importar Ventas</span>
          <button className="close-btn" onClick={onClose}>
            ×
          </button>
        </div>
        <div className="modal-content-import">
          <label htmlFor="archivo">Selecciona un archivo Excel:</label>
          <input
            type="file"
            id="archivo"
            accept=".xlsx,.xls"
            onChange={handleFileChange}
          />
        </div>

        <div className="modal-footer">
          <button className="cancel-btn" onClick={onClose}>
            Cancelar
          </button>
          <button className="save-btn" onClick={handleImportar}>
            Importar
          </button>
        </div>
      </div>
    </div>
  );
};

ImportarVenta.propTypes = {
  onClose: PropTypes.func.isRequired,
  token: PropTypes.string.isRequired,
  onSuccess: PropTypes.func.isRequired,
};

export default ImportarVenta;
